"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 15: Multicart
 * ------------------------------------------------------------------ */
// Multicart

function register(Mappers) {
  Mappers[15] = function (nes) {
    this.nes = nes;
  };

  Mappers[15].prototype = new Mappers[0]();

  Mappers[15].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.bankLo = 0;
    this.bankHi = 0;
    this.prgBanks = [0, 0, 0, 0];
  };

  Mappers[15].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // The high nibble picks one of four 16 KB banks, one per 8 KB window.
    var bank = value & 0x0f;
    switch (address & 0xf000) {
      case 0x8000:
        this.bankLo = bank;
        break;
      case 0x9000:
        this.prgBanks[1] = bank;
        break;
      case 0xa000:
        this.prgBanks[2] = bank;
        break;
      case 0xb000:
        this.prgBanks[3] = bank;
        break;
      case 0xc000:
      case 0xd000:
        this.bankHi = bank;
        break;
      default:
        // $E000/$F000 are reads only on this board.
        return;
    }

    this.prgBanks[0] = this.bankLo;
    this.updateBanks();
  };

  Mappers[15].prototype.updateBanks = function () {
    var romCount = this.nes.rom.romCount;
    for (var i = 0; i < 4; i++) {
      var bank = (this.prgBanks[i] * 4 + i) % romCount;
      this.load8kRomBank(bank, 0x8000 + i * 0x2000);
    }
  };

  Mappers[15].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Multicart: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.updateBanks();
    this.resetIrqHandler();
  };

  Mappers[15].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.bankLo = this.bankLo;
    s.bankHi = this.bankHi;
    s.prgBanks = this.prgBanks.slice();
    return s;
  };

  Mappers[15].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.bankLo = s.bankLo;
    this.bankHi = s.bankHi;
    this.prgBanks = s.prgBanks.slice();
    this.updateBanks();
  };
}

module.exports = { register: register };
